'use client';

import { useEffect, useRef } from 'react';

const VISIBLE_THRESHOLD = 0.5;

export function useTrackWhenVisible<T extends Element>(
  key: string | null,
  track: () => void
) {
  const ref = useRef<T>(null);
  const trackRef = useRef(track);

  useEffect(() => {
    trackRef.current = track;
  });

  useEffect(() => {
    const element = ref.current;
    if (!key || !element) return;
    if (typeof IntersectionObserver === 'undefined') {
      trackRef.current();
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        trackRef.current();
      },
      { threshold: VISIBLE_THRESHOLD }
    );
    observer.observe(element);
    return () => observer.disconnect();
  }, [key]);

  return ref;
}
